<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useVersionReload } from "@/composables/shared/useVersionReload";

const props = defineProps<{
  noOffset?: boolean;
}>();

const { t } = useI18n();

const { isUpdateDeferred } = useVersionReload();
</script>

<template>
  <div
    v-if="isUpdateDeferred"
    class="tw:bg-surface tw:rounded-md"
    :class="{ 'tw:!mb-2': !props.noOffset }"
  >
    <v-alert
      class="tw:text-sm tw:font-semibold tw:text-center tw:!bg-phase05/15 tw:border-4 tw:border-surface tw:!text-warning tw:!rounded-md"
      density="compact"
    >
      <template #text>
        <div class="tw:leading-none">
          <v-icon
            class="tw:!-mt-0.5 tw:!mr-1"
            color="warning"
            >mdi-alert-circle</v-icon
          >
          {{ t("generic.alerts.newVersionWaitingUntilFormDone") }}
        </div>
      </template>
    </v-alert>
  </div>
</template>
